import { render } from "./ImportCardType.vue?vue&type=template&id=4ed96de3&scoped=true"
import script from "./ImportCardType.vue?vue&type=script&lang=js"
export * from "./ImportCardType.vue?vue&type=script&lang=js"

import "./ImportCardType.vue?vue&type=style&index=0&id=4ed96de3&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ed96de3"]])

export default __exports__